import { BRIEF_LIMITS } from "./briefLimits.js";
/** Public guidance contains field names and constraints, never rejected input values. */
export function briefValidationIssues(issues) {
    return issues.map(issue => {
        const field = issue.path.join(".");
        const index = typeof issue.path[1] === "number" ? issue.path[1] + 1 : null;
        let message;
        if (field === "business.contact.email")
            message = "Enter a valid email address, or leave Email blank.";
        else if (field === "business.description")
            message = `Describe your business in at least ${BRIEF_LIMITS.descriptionMinimum} characters.`;
        else if (field === "business.name")
            message = "Enter your business name.";
        else if (field === "business.type")
            message = "Choose a business type.";
        else if (field.startsWith("business.contact"))
            message = "Check the contact details you entered.";
        else if (field.startsWith("business.hours"))
            message = "Check your opening hours.";
        else if (field === "ownerNote")
            message = `Keep Anything else under ${BRIEF_LIMITS.ownerNote.toLocaleString("en-US")} characters.`;
        else if (field === "attachments")
            message = `Use up to ${BRIEF_LIMITS.attachments} files per site. Remove extra files before continuing.`;
        else if (field.startsWith("attachments."))
            message = `File ${index ?? "upload"} could not be read. Remove it and upload it again.`;
        else if (field.startsWith("inspo"))
            message = `Check inspiration link${index ? ` ${index}` : "s"}. Use a website address such as example.com.`;
        else if (field.startsWith("voice"))
            message = "Check your animation preference in Inspiration.";
        else if (field.startsWith("capabilities"))
            message = "Check the features selected for your site.";
        else if (field.startsWith("integration"))
            message = "Check the integrations selected for your site.";
        else
            message = "Some saved business details need updating. Review your information and try again.";
        return { field, message };
    });
}
export function briefValidationProblem(issues) {
    return {
        error: "Please check your site details below.", code: "invalid_brief",
        issues: briefValidationIssues(issues),
    };
}
